document.addEventListener('DOMContentLoaded', function () {
  function buildWaUrl(title) {
    var msg = 'Hi! I want to inquire now about ' + title;
    return 'https://wa.me/97142590877?text=' + encodeURIComponent(msg);
  }

  function hideBuyNowButtons() {
    document.querySelectorAll('.shopify-payment-button').forEach(function (el) {
      el.style.display = 'none';
    });
  }

  function swapButton(btn) {
    if (!btn || btn.dataset.hhOosSwapped) return;
    var titleEl = document.querySelector('.product-info h1, h1.product-title, h1');
    var title = titleEl ? titleEl.textContent.trim() : document.title;
    var link = document.createElement('a');
    link.href = buildWaUrl(title);
    link.target = '_blank';
    link.rel = 'noopener';
    link.className = btn.className;
    link.setAttribute('data-hh-oos-swapped', 'true');
    link.setAttribute('data-hh-track', 'inquire_now');
    link.innerHTML = '<span>Inquire Now</span>';
    btn.parentNode.replaceChild(link, btn);
    hideBuyNowButtons();
  }

  var oosButtons = document.querySelectorAll('button.button-add-to-cart[disabled]');
  if (oosButtons.length > 0) {
    hideBuyNowButtons();
  }
  oosButtons.forEach(swapButton);
});
